(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dawave-army-feed"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(){
      document.querySelectorAll('[data-dwa-feed]').forEach(function(feed){
        if(feed.dataset.dwaInit) return;
        feed.dataset.dwaInit = '1';
        var id = feed.getAttribute('data-dwa-feed');
        var dataEl = document.querySelector('[data-dwa-feed-data="' + id + '"]');
        var pool = [];
        try{ pool = JSON.parse(dataEl.textContent); }catch(e){ pool = []; }
        if(pool.length < 2) return;
        var pi = 0;
        setInterval(function(){
          var p = pool[pi % pool.length]; pi++;
          var row = document.createElement('div');
          row.className = 'feed-row';
          row.innerHTML = '<div class="avatar">'+p.i+'</div><div class="who"><div class="name">'+p.n+'</div><div class="meta">'+p.t+'</div></div><div class="amt">'+p.a+'</div>';
          feed.insertBefore(row, feed.firstChild);
          while(feed.children.length > 4) feed.removeChild(feed.lastChild);
        }, 5200);
      });
    }
    if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dawave-army-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function animateCount(el){
      var target = parseFloat(el.getAttribute('data-count'));
      if(isNaN(target)) return;
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var dur = 1300, start = null;
      function frame(t){
        if(!start) start = t;
        var p = Math.min((t-start)/dur, 1);
        var eased = 1 - Math.pow(1-p, 3);
        el.textContent = prefix + Math.round(target*eased).toLocaleString() + suffix;
        if(p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }
    function init(){
      document.querySelectorAll('.dwa-hero .stats').forEach(function(stats){
        if(stats.dataset.dwaCounted) return;
        stats.dataset.dwaCounted = '1';
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){
              stats.querySelectorAll('.stat .num[data-count]').forEach(animateCount);
              io.disconnect();
            }
          });
        }, {threshold:.4});
        io.observe(stats);
      });
    }
    if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dw-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  var P = 'dwbs';
  function q(el, k) { return el.querySelector('[data-' + P + '-' + k + ']'); }

  function makeMoney(fmt) {
    fmt = fmt || '${{amount}}';
    function grp(c, d, ts, ds) {
      var parts = (c / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    return function (cents) {
      cents = Number(cents) || 0;
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', n;
      if (key === 'amount_no_decimals') n = grp(cents, 0, ',', '.');
      else if (key === 'amount_with_comma_separator') n = grp(cents, 2, '.', ',');
      else if (key === 'amount_no_decimals_with_comma_separator') n = grp(cents, 0, '.', ',');
      else if (key === 'amount_with_apostrophe_separator') n = grp(cents, 2, "'", '.');
      else n = grp(cents, 2, ',', '.');
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
    };
  }

  function refreshCart() {
    if (typeof window.monster_refresh === 'function') {
      try { window.monster_refresh(); } catch (e) {}
    } else {
      console.warn('[' + P + '] window.monster_refresh() not found. Confirm Monster Cart is installed.');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function setState(btn, state) {
    var txt = btn.querySelector('.' + P + '-atc__text');
    if (txt && !btn.hasAttribute('data-label')) btn.setAttribute('data-label', txt.textContent);
    btn.classList.remove('is-loading', 'is-added');
    if (state === 'loading') { btn.classList.add('is-loading'); btn.disabled = true; return; }
    btn.disabled = false;
    if (state === 'added') {
      btn.classList.add('is-added');
      if (txt) txt.textContent = 'Added';
      clearTimeout(btn._t);
      btn._t = setTimeout(function () {
        btn.classList.remove('is-added');
        if (txt) txt.textContent = btn.getAttribute('data-label') || 'Add to cart';
      }, 1800);
    } else if (txt) {
      txt.textContent = btn.getAttribute('data-label') || 'Add to cart';
    }
  }

  function addToCart(id, btn) {
    if (!id) return Promise.resolve(false);
    setState(btn, 'loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'Could not add to cart.');
        refreshCart();
        setState(btn, 'added');
        return true;
      })
      .catch(function (err) {
        setState(btn, 'reset');
        alert(err.message || 'Could not add to cart.');
        return false;
      });
  }

  function init(root) {
    if (!root || root.dataset.init === 'true') return;
    root.dataset.init = 'true';
    var money = makeMoney(root.getAttribute('data-money-format'));

    var modal = q(root, 'modal');
    var mImg = q(modal, 'm-img'), mTitle = q(modal, 'm-title'), mPrice = q(modal, 'm-price');
    var mOpts = q(modal, 'm-options'), mAtc = q(modal, 'm-atc');
    var prod = null, sel = [];

    function close() { modal.setAttribute('hidden', ''); prod = null; }
    modal.querySelectorAll('[data-' + P + '-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close(); });

    function match() {
      if (!prod) return null;
      return prod.variants.find(function (v) {
        return v.options.every(function (o, i) { return String(o) === String(sel[i]); });
      }) || null;
    }

    function render() {
      var v = match();
      mOpts.querySelectorAll('.' + P + '-modal__value').forEach(function (b) {
        var pos = parseInt(b.dataset.pos, 10);
        var ok = prod.variants.some(function (vr) {
          return vr.available && vr.options.every(function (o, i) {
            return i === pos ? String(o) === b.dataset.value : String(o) === String(sel[i]);
          });
        });
        b.classList.toggle('is-unavailable', !ok);
        b.classList.toggle('is-selected', b.dataset.value === String(sel[pos]));
      });
      if (v) {
        var h = '<span>' + money(v.price) + '</span>';
        if (v.compareAtPrice && v.compareAtPrice > v.price) h += '<s>' + money(v.compareAtPrice) + '</s>';
        mPrice.innerHTML = h;
        if (v.image) mImg.src = v.image;
      }
      mAtc.disabled = !(v && v.available);
      var t = mAtc.querySelector('.' + P + '-atc__text');
      if (t) t.textContent = (v && v.available) ? 'Add to cart' : (v ? 'Sold out' : 'Select options');
    }

    function open(p) {
      prod = p;
      mTitle.textContent = p.title;
      mImg.src = p.featuredImage || '';
      mImg.alt = p.title;
      var base = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      sel = base ? base.options.slice() : [];
      mOpts.innerHTML = '';
      p.options.forEach(function (opt, idx) {
        var wrap = document.createElement('div'); wrap.className = P + '-modal__opt';
        var lab = document.createElement('span'); lab.className = P + '-modal__opt-name'; lab.textContent = opt.name;
        var vals = document.createElement('div'); vals.className = P + '-modal__values';
        opt.values.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = P + '-modal__value'; b.textContent = val;
          b.dataset.pos = idx; b.dataset.value = String(val);
          b.addEventListener('click', function () { sel[idx] = String(val); render(); });
          vals.appendChild(b);
        });
        wrap.appendChild(lab); wrap.appendChild(vals); mOpts.appendChild(wrap);
      });
      render();
      modal.removeAttribute('hidden');
    }

    mAtc.addEventListener('click', function () {
      var v = match();
      if (!v || !v.available) return;
      addToCart(v.id, mAtc).then(function (ok) { if (ok) setTimeout(close, 600); });
    });

    root.querySelectorAll('[data-' + P + '-card]').forEach(function (card) {
      var btn = q(card, 'atc');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-has-variants') === 'true') {
          var p = null;
          try { p = JSON.parse(q(card, 'json').textContent); } catch (e) {}
          if (p) open(p);
          else { var a = card.querySelector('a'); if (a) window.location.href = a.href; }
          return;
        }
        addToCart(btn.getAttribute('data-variant-id'), btn);
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-' + P + '-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-' + P + '-root]');
    if (r) { r.dataset.init = 'false'; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dw-compare-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  function makeMoney(fmt) {
    fmt = fmt || '${{amount}}';
    function grp(c, d, ts, ds) {
      var parts = (c / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    return function (cents) {
      cents = Number(cents) || 0;
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', n;
      if (key === 'amount_no_decimals') n = grp(cents, 0, ',', '.');
      else if (key === 'amount_with_comma_separator') n = grp(cents, 2, '.', ',');
      else if (key === 'amount_no_decimals_with_comma_separator') n = grp(cents, 0, '.', ',');
      else if (key === 'amount_with_apostrophe_separator') n = grp(cents, 2, "'", '.');
      else n = grp(cents, 2, ',', '.');
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
    };
  }
  function fill(tpl, name, price) {
    return String(tpl || '').split('{title}').join(name).split('{price}').join(price);
  }
  function refreshCart() {
    if (typeof window.monster_refresh === 'function') {
      try { window.monster_refresh(); } catch (e) {}
    } else {
      console.warn('[dwct] window.monster_refresh() not found. Confirm Monster Cart is installed.');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function init(root) {
    if (!root || root.dataset.init === 'true') return;
    root.dataset.init = 'true';

    /* swipe state: hint + fade only when the table actually overflows */
    var wrap = root.querySelector('[data-dwct-wrap]');
    var sc = root.querySelector('[data-dwct-scroller]');
    function measure() {
      var scrollable = sc.scrollWidth > sc.clientWidth + 2;
      wrap.classList.toggle('is-scrollable', scrollable);
      wrap.classList.toggle('is-end', sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4);
    }
    sc.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    measure();

    /* live price + variant from the main product form */
    var btn = root.querySelector('[data-dwct-btn]');
    if (!btn) return;
    var money = makeMoney(root.getAttribute('data-money-format'));
    var txt = btn.querySelector('[data-dwct-btn-text]');
    var usName = root.querySelector('[data-dwct-usname]');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-dwct-variants]').textContent); } catch (e) {}

    function currentVariantId() {
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      var inputs = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
      for (var i = 0; i < inputs.length; i++) {
        if (!root.contains(inputs[i]) && inputs[i].value) return inputs[i].value;
      }
      return fromUrl;
    }
    function render() {
      var id = currentVariantId();
      var v = variants.find(function (x) { return String(x.id) === String(id); });
      if (!v) v = variants.find(function (x) { return String(x.id) === btn.getAttribute('data-variant-id'); }) || variants[0];
      if (!v) return;
      btn.setAttribute('data-variant-id', v.id);
      var price = money(v.price);
      if (btn.classList.contains('is-added') || btn.classList.contains('is-loading')) return;
      btn.classList.toggle('is-soldout', !v.available);
      txt.innerHTML = v.available ? fill(btn.getAttribute('data-tpl'), btn.getAttribute('data-name'), price) : 'Sold out';
      if (usName) usName.innerHTML = fill(usName.getAttribute('data-tpl'), usName.getAttribute('data-name'), price);
    }
    var t;
    function soon() { clearTimeout(t); t = setTimeout(render, 60); }
    document.addEventListener('change', soon, true);
    ['variant:change', 'variant:changed', 'on:variant:change', 'product:variant-change'].forEach(function (ev) {
      document.addEventListener(ev, soon);
    });
    window.addEventListener('popstate', soon);
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      if (orig && !orig._dwct) {
        history[fn] = function () { var r = orig.apply(this, arguments); window.dispatchEvent(new Event('dwct:url')); return r; };
        history[fn]._dwct = true;
      }
    });
    window.addEventListener('dwct:url', soon);
    render();

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-soldout')) return;
      var label = txt.innerHTML;
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && res.d.description) || 'Could not add to cart.');
          refreshCart();
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          txt.textContent = 'Added';
          setTimeout(function () { btn.classList.remove('is-added'); txt.innerHTML = label; render(); }, 1800);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          alert(err.message || 'Could not add to cart.');
        });
    });
  }

  function initAll() { document.querySelectorAll('[data-dwct-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-dwct-root]');
    if (r) { r.dataset.init = 'false'; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dw-hero-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function makeMoney(fmt) {
    fmt = fmt || '${{amount}}';
    function grp(c, d, ts, ds) {
      var parts = (c / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    return function (cents) {
      cents = Number(cents) || 0;
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', n;
      if (key === 'amount_no_decimals') n = grp(cents, 0, ',', '.');
      else if (key === 'amount_with_comma_separator') n = grp(cents, 2, '.', ',');
      else if (key === 'amount_no_decimals_with_comma_separator') n = grp(cents, 0, '.', ',');
      else if (key === 'amount_with_apostrophe_separator') n = grp(cents, 2, "'", '.');
      else n = grp(cents, 2, ',', '.');
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
    };
  }

  function refreshCart() {
    if (typeof window.monster_refresh === 'function') {
      try { window.monster_refresh(); } catch (e) {}
    } else {
      console.warn('[dwh3] window.monster_refresh() not found. Confirm Monster Cart is installed.');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function setState(btn, state) {
    var txt = btn.querySelector('.dwh3__bshop-text, .dwh3-modal__atc-text');
    if (txt && !btn.hasAttribute('data-label')) btn.setAttribute('data-label', txt.textContent);
    btn.classList.remove('is-loading', 'is-added');
    if (state === 'loading') { btn.classList.add('is-loading'); btn.disabled = true; return; }
    btn.disabled = false;
    if (state === 'added') {
      btn.classList.add('is-added');
      if (txt) txt.textContent = 'Added';
      clearTimeout(btn._t);
      btn._t = setTimeout(function () {
        btn.classList.remove('is-added');
        if (txt) txt.textContent = btn.getAttribute('data-label');
      }, 1800);
    } else if (txt) {
      txt.textContent = btn.getAttribute('data-label');
    }
  }

  function addToCart(id, btn) {
    if (!id) return Promise.resolve(false);
    setState(btn, 'loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'Could not add to cart.');
        refreshCart();
        setState(btn, 'added');
        return true;
      })
      .catch(function (err) {
        setState(btn, 'reset');
        alert(err.message || 'Could not add to cart.');
        return false;
      });
  }

  function initCart(root) {
    var btn = root.querySelector('[data-dwh3-atc]');
    if (!btn) return;
    var money = makeMoney(root.getAttribute('data-money-format'));
    var modal = root.querySelector('[data-dwh3-modal]');
    var mImg = modal.querySelector('[data-dwh3-m-img]');
    var mTitle = modal.querySelector('[data-dwh3-m-title]');
    var mPrice = modal.querySelector('[data-dwh3-m-price]');
    var mOpts = modal.querySelector('[data-dwh3-m-options]');
    var mAtc = modal.querySelector('[data-dwh3-m-atc]');
    var prod = null, sel = [];

    function close() { modal.setAttribute('hidden', ''); }
    modal.querySelectorAll('[data-dwh3-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close(); });

    function match() {
      return prod && prod.variants.find(function (v) {
        return v.options.every(function (o, i) { return String(o) === String(sel[i]); });
      }) || null;
    }
    function render() {
      var v = match();
      mOpts.querySelectorAll('.dwh3-modal__value').forEach(function (b) {
        var pos = parseInt(b.dataset.pos, 10);
        var ok = prod.variants.some(function (vr) {
          return vr.available && vr.options.every(function (o, i) {
            return i === pos ? String(o) === b.dataset.value : String(o) === String(sel[i]);
          });
        });
        b.classList.toggle('is-unavailable', !ok);
        b.classList.toggle('is-selected', b.dataset.value === String(sel[pos]));
      });
      if (v) {
        var h = '<span>' + money(v.price) + '</span>';
        if (v.compareAtPrice && v.compareAtPrice > v.price) h += '<s>' + money(v.compareAtPrice) + '</s>';
        mPrice.innerHTML = h;
        if (v.image) mImg.src = v.image;
      }
      mAtc.disabled = !(v && v.available);
      var t = mAtc.querySelector('.dwh3-modal__atc-text');
      if (t) t.textContent = (v && v.available) ? 'Add to cart' : (v ? 'Sold out' : 'Select options');
    }
    function open(p) {
      prod = p;
      mTitle.textContent = p.title;
      mImg.src = p.featuredImage || '';
      mImg.alt = p.title;
      var base = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      sel = base ? base.options.slice() : [];
      mOpts.innerHTML = '';
      p.options.forEach(function (opt, idx) {
        var wrap = document.createElement('div'); wrap.className = 'dwh3-modal__opt';
        var lab = document.createElement('span'); lab.className = 'dwh3-modal__opt-name'; lab.textContent = opt.name;
        var vals = document.createElement('div'); vals.className = 'dwh3-modal__values';
        opt.values.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'dwh3-modal__value'; b.textContent = val;
          b.dataset.pos = idx; b.dataset.value = String(val);
          b.addEventListener('click', function () { sel[idx] = String(val); render(); });
          vals.appendChild(b);
        });
        wrap.appendChild(lab); wrap.appendChild(vals); mOpts.appendChild(wrap);
      });
      render();
      modal.removeAttribute('hidden');
    }

    mAtc.addEventListener('click', function () {
      var v = match();
      if (!v || !v.available) return;
      addToCart(v.id, mAtc).then(function (ok) { if (ok) setTimeout(close, 600); });
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      if (btn.getAttribute('data-has-variants') === 'true') {
        var p = null;
        try { p = JSON.parse(root.querySelector('[data-dwh3-json]').textContent); } catch (e) {}
        if (p) open(p); else window.location.href = btn.href;
        return;
      }
      addToCart(btn.getAttribute('data-variant-id'), btn);
    });
  }

  function init(root) {
    if (!root || root.dataset.init === 'true') return;
    root.dataset.init = 'true';
    initCart(root);
    var wrap = root.querySelector('[data-dwh3-video]');
    var video = wrap && wrap.querySelector('video');
    if (!video) return;
    var play = wrap.querySelector('[data-dwh3-play]');
    var mute = wrap.querySelector('[data-dwh3-mute]');
    var auto = wrap.classList.contains('is-auto');

    function sync() { wrap.classList.toggle('is-playing', !video.paused && !video.ended); }
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);

    if (auto) {
      var p = video.play();
      if (p && p.catch) p.catch(function () { wrap.classList.remove('is-playing'); });
      mute.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        wrap.classList.toggle('is-unmuted', !video.muted);
      });
    }

    play.addEventListener('click', function () {
      if (!auto) video.muted = false;
      video.play();
    });
    video.addEventListener('click', function () {
      if (auto) { video.muted = !video.muted; wrap.classList.toggle('is-unmuted', !video.muted); return; }
      if (video.paused) video.play(); else video.pause();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting && !video.paused && !auto) video.pause();
        });
      }, { threshold: 0.2 }).observe(wrap);
    }
  }
  function initAll() { document.querySelectorAll('[data-dwh3-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-dwh3-root]');
    if (r) { r.dataset.init = 'false'; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dw-offer-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  var P = 'dwob';
  function q(el, k) { return el.querySelector('[data-' + P + '-' + k + ']'); }

  function makeMoney(fmt) {
    fmt = fmt || '${{amount}}';
    function grp(c, d, ts, ds) {
      var parts = (c / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[0] + (parts[1] ? ds + parts[1] : '');
    }
    return function (cents) {
      cents = Number(cents) || 0;
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', n;
      if (key === 'amount_no_decimals') n = grp(cents, 0, ',', '.');
      else if (key === 'amount_with_comma_separator') n = grp(cents, 2, '.', ',');
      else if (key === 'amount_no_decimals_with_comma_separator') n = grp(cents, 0, '.', ',');
      else if (key === 'amount_with_apostrophe_separator') n = grp(cents, 2, "'", '.');
      else n = grp(cents, 2, ',', '.');
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
    };
  }

  function refreshCart() {
    if (typeof window.monster_refresh === 'function') {
      try { window.monster_refresh(); } catch (e) {}
    } else {
      console.warn('[' + P + '] window.monster_refresh() not found. Confirm Monster Cart is installed.');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  function setState(btn, state) {
    var txt = btn.querySelector('.' + P + '-atc__text');
    if (txt && !btn.hasAttribute('data-label')) btn.setAttribute('data-label', txt.textContent);
    btn.classList.remove('is-loading', 'is-added');
    if (state === 'loading') { btn.classList.add('is-loading'); btn.disabled = true; return; }
    btn.disabled = false;
    if (state === 'added') {
      btn.classList.add('is-added');
      if (txt) txt.textContent = 'Added';
      clearTimeout(btn._t);
      btn._t = setTimeout(function () {
        btn.classList.remove('is-added');
        if (txt) txt.textContent = btn.getAttribute('data-label') || 'Add to cart';
      }, 1800);
    } else if (txt) {
      txt.textContent = btn.getAttribute('data-label') || 'Add to cart';
    }
  }

  function addToCart(id, btn) {
    if (!id) return Promise.resolve(false);
    setState(btn, 'loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'Could not add to cart.');
        refreshCart();
        setState(btn, 'added');
        return true;
      })
      .catch(function (err) {
        setState(btn, 'reset');
        alert(err.message || 'Could not add to cart.');
        return false;
      });
  }

  function init(root) {
    if (!root || root.dataset.init === 'true') return;
    root.dataset.init = 'true';
    var money = makeMoney(root.getAttribute('data-money-format'));

    var modal = q(root, 'modal');
    var mImg = q(modal, 'm-img'), mTitle = q(modal, 'm-title'), mPrice = q(modal, 'm-price');
    var mOpts = q(modal, 'm-options'), mAtc = q(modal, 'm-atc');
    var prod = null, sel = [];

    function close() { modal.setAttribute('hidden', ''); prod = null; }
    modal.querySelectorAll('[data-' + P + '-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close(); });

    function match() {
      if (!prod) return null;
      return prod.variants.find(function (v) {
        return v.options.every(function (o, i) { return String(o) === String(sel[i]); });
      }) || null;
    }

    function render() {
      var v = match();
      mOpts.querySelectorAll('.' + P + '-modal__value').forEach(function (b) {
        var pos = parseInt(b.dataset.pos, 10);
        var ok = prod.variants.some(function (vr) {
          return vr.available && vr.options.every(function (o, i) {
            return i === pos ? String(o) === b.dataset.value : String(o) === String(sel[i]);
          });
        });
        b.classList.toggle('is-unavailable', !ok);
        b.classList.toggle('is-selected', b.dataset.value === String(sel[pos]));
      });
      if (v) {
        var h = '<span>' + money(v.price) + '</span>';
        if (v.compareAtPrice && v.compareAtPrice > v.price) h += '<s>' + money(v.compareAtPrice) + '</s>';
        mPrice.innerHTML = h;
        if (v.image) mImg.src = v.image;
      }
      mAtc.disabled = !(v && v.available);
      var t = mAtc.querySelector('.' + P + '-atc__text');
      if (t) t.textContent = (v && v.available) ? 'Add to cart' : (v ? 'Sold out' : 'Select options');
    }

    function open(p) {
      prod = p;
      mTitle.textContent = p.title;
      mImg.src = p.featuredImage || '';
      mImg.alt = p.title;
      var base = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      sel = base ? base.options.slice() : [];
      mOpts.innerHTML = '';
      p.options.forEach(function (opt, idx) {
        var wrap = document.createElement('div'); wrap.className = P + '-modal__opt';
        var lab = document.createElement('span'); lab.className = P + '-modal__opt-name'; lab.textContent = opt.name;
        var vals = document.createElement('div'); vals.className = P + '-modal__values';
        opt.values.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = P + '-modal__value'; b.textContent = val;
          b.dataset.pos = idx; b.dataset.value = String(val);
          b.addEventListener('click', function () { sel[idx] = String(val); render(); });
          vals.appendChild(b);
        });
        wrap.appendChild(lab); wrap.appendChild(vals); mOpts.appendChild(wrap);
      });
      render();
      modal.removeAttribute('hidden');
    }

    mAtc.addEventListener('click', function () {
      var v = match();
      if (!v || !v.available) return;
      addToCart(v.id, mAtc).then(function (ok) { if (ok) setTimeout(close, 600); });
    });

    root.querySelectorAll('[data-' + P + '-card]').forEach(function (card) {
      var btn = q(card, 'atc');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-has-variants') === 'true') {
          var p = null;
          try { p = JSON.parse(q(card, 'json').textContent); } catch (e) {}
          if (p) open(p);
          else { var a = card.querySelector('a'); if (a) window.location.href = a.href; }
          return;
        }
        addToCart(btn.getAttribute('data-variant-id'), btn);
      });
    });
  }

  function initAll() { document.querySelectorAll('[data-' + P + '-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-' + P + '-root]');
    if (r) { r.dataset.init = 'false'; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-02"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-02');
            this.header_1 = document.querySelector('.enable_parallax');
            if (this.header_1 != null) {
              this.heightEle = this.header_1.clientHeight;
            } else {
              this.heightEle = this.header.clientHeight;
            }
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-03"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-03');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-04"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-04');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.HeaderAnnouncement = document.getElementById('shopify-section-announcement-bar').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (document.getElementById('shopify-section-announcement-bar') && this.HeaderAnnouncement > 0) {
                var headerHeight = this.header.clientHeight + this.HeaderAnnouncement
            } else {
                var headerHeight = this.header.clientHeight
            }
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > headerHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > headerHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (headerHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
            if(!$('.header-04').hasClass('style_3')){
                $('.vertical-menu').addClass('hide');
            }
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
            if(!$('.header-04').hasClass('style_3')){
                if ($('.vertical-menu').hasClass('open')) {
                    $('.vertical-menu').removeClass('hide');
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-05"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-05');
            this.header_1 = document.querySelector('.enable_parallax');
            if (this.header_1 != null) {
              this.heightEle = this.header_1.clientHeight;
            } else {
              this.heightEle = this.header.clientHeight;
            }
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-06"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-06');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }
        
        disconnectedCallback() {
            window.removeEventListener('resize', this.onResizeHandler);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }
        
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
                if (window.innerWidth > 1200 && document.querySelector('.layout_search--style2')) {
                    const openDetailsElement = this.querySelector('details[open]');
                    if (openDetailsElement) {
                        const summaryElement = openDetailsElement.querySelector('summary');
                        openDetailsElement.removeAttribute('open');
                        summaryElement.focus();
                        document.body.classList.remove('open_search');
                    }
                }
                if (!document.body.classList.contains('cart-sidebar-show') && 
                    !document.body.classList.contains('sticky-search-open')) {
                    if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                        requestAnimationFrame(this.reset.bind(this));
                    }
                    this.check = true;
                    this.currentScrollTop = scrollTop;
                }
            } else {
                this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-07"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-07');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
                if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                    if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                        requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
                }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-08"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-08');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-09"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-09');
            this.heightEle = this.header.clientHeight;
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-10"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-10');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }
        
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nrm-crowd-favourites"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (!section || section.dataset.nrmCfInit === 'true') return;
    section.dataset.nrmCfInit = 'true';

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
        return Shopify.formatMoney(cents, Shopify.money_format);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    var tabs = section.querySelectorAll('[data-nrm-cf-tab]');
    var panels = section.querySelectorAll('[data-nrm-cf-panel]');
    var viewAll = section.querySelector('[data-nrm-cf-view-all]');

    function activateTab(idx) {
      tabs.forEach(function (t) {
        var on = (parseInt(t.dataset.tabIndex, 10) === idx);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', parseInt(p.dataset.tabIndex, 10) === idx);
      });
      if (viewAll) {
        var activeTab = section.querySelector('[data-nrm-cf-tab][data-tab-index="' + idx + '"]');
        if (activeTab) {
          var url = activeTab.getAttribute('data-collection-url');
          if (url) viewAll.setAttribute('href', url);
        }
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.dataset.tabIndex, 10);
        if (tab.classList.contains('is-active')) return;
        activateTab(idx);
      });
    });

    function refreshCart() {
      if (typeof window.monster_refresh === 'function') {
        try { window.monster_refresh(); } catch (e) {}
      } else {
        console.warn('[NRM-CF] window.monster_refresh() not found - confirm Monster Cart is installed.');
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }

    function setBtnState(button, state) {
      if (!button) return;
      var txt = button.querySelector('.nrm-cf-atc__text');
      if (txt && button.getAttribute('data-label') === null) {
        button.setAttribute('data-label', txt.textContent);
      }
      button.classList.remove('is-loading', 'is-added');
      if (state === 'loading') {
        button.classList.add('is-loading');
        button.disabled = true;
      } else if (state === 'added') {
        button.disabled = false;
        button.classList.add('is-added');
        if (txt) txt.textContent = 'Added';
        clearTimeout(button._nrmTimer);
        button._nrmTimer = setTimeout(function () {
          button.classList.remove('is-added');
          if (txt) txt.textContent = button.getAttribute('data-label') || 'Add to cart';
        }, 1800);
      } else {
        button.disabled = false;
        if (txt) txt.textContent = button.getAttribute('data-label') || 'Add to cart';
      }
    }

    function addToCart(variantId, button) {
      if (!variantId) return Promise.resolve(false);
      setBtnState(button, 'loading');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            throw new Error(res.data && res.data.description ? res.data.description : 'Could not add to cart.');
          }
          refreshCart();
          setBtnState(button, 'added');
          return true;
        })
        .catch(function (err) {
          setBtnState(button, 'reset');
          alert(err.message || 'Could not add to cart.');
          return false;
        });
    }

    var modal = section.querySelector('[data-nrm-cf-modal]');
    var modalImg = modal.querySelector('[data-nrm-cf-modal-img]');
    var modalTitle = modal.querySelector('[data-nrm-cf-modal-title]');
    var modalPrice = modal.querySelector('[data-nrm-cf-modal-price]');
    var modalOptions = modal.querySelector('[data-nrm-cf-modal-options]');
    var modalAtc = modal.querySelector('[data-nrm-cf-modal-atc]');
    var activeProduct = null;
    var selectedValues = [];

    function closeModal() {
      modal.setAttribute('hidden', '');
      activeProduct = null;
    }
    modal.querySelectorAll('[data-nrm-cf-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });

    function getMatchedVariant() {
      if (!activeProduct) return null;
      return activeProduct.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return String(opt) === String(selectedValues[i]);
        });
      }) || null;
    }

    function optionValueText(val) {
      return (val && typeof val === 'object') ? (val.name || val.title || '') : val;
    }

    function renderModalState() {
      var v = getMatchedVariant();
      modalOptions.querySelectorAll('.nrm-cf-modal__value').forEach(function (btn) {
        var pos = parseInt(btn.dataset.pos, 10);
        var test = selectedValues.slice();
        test[pos] = btn.dataset.value;
        var exists = activeProduct.variants.some(function (vr) {
          return vr.available && vr.options.every(function (o, i) {
            return i === pos ? String(o) === String(btn.dataset.value) : String(o) === String(test[i]);
          });
        });
        btn.classList.toggle('is-unavailable', !exists);
        btn.classList.toggle('is-selected', String(btn.dataset.value) === String(selectedValues[pos]));
      });

      if (v) {
        var html = '<span>' + formatMoney(v.price) + '</span>';
        if (v.compareAtPrice && v.compareAtPrice > v.price) {
          html += '<s>' + formatMoney(v.compareAtPrice) + '</s>';
        }
        modalPrice.innerHTML = html;
        if (v.image) modalImg.src = v.image;
      }

      modalAtc.disabled = !(v && v.available);
      var txt = modalAtc.querySelector('.nrm-cf-atc__text');
      if (txt) txt.textContent = (v && v.available) ? 'Add to cart' : (v ? 'Sold out' : 'Select options');
    }

    function openModal(product) {
      activeProduct = product;
      modalTitle.textContent = product.title;
      modalImg.src = product.featuredImage || '';
      modalImg.alt = product.title;

      var base = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      selectedValues = base ? base.options.slice() : [];

      modalOptions.innerHTML = '';
      product.options.forEach(function (opt, idx) {
        var wrap = document.createElement('div');
        wrap.className = 'nrm-cf-modal__opt';
        var label = document.createElement('span');
        label.className = 'nrm-cf-modal__opt-name';
        label.textContent = opt.name;
        wrap.appendChild(label);

        var values = document.createElement('div');
        values.className = 'nrm-cf-modal__values';
        opt.values.forEach(function (val) {
          var text = optionValueText(val);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'nrm-cf-modal__value';
          btn.textContent = text;
          btn.dataset.pos = idx;
          btn.dataset.value = text;
          btn.addEventListener('click', function () {
            selectedValues[idx] = text;
            renderModalState();
          });
          values.appendChild(btn);
        });
        wrap.appendChild(values);
        modalOptions.appendChild(wrap);
      });

      renderModalState();
      modal.removeAttribute('hidden');
    }

    modalAtc.addEventListener('click', function () {
      var v = getMatchedVariant();
      if (!v || !v.available) return;
      addToCart(v.id, modalAtc).then(function (ok) { if (ok) closeModal(); });
    });

    /* Notify me links have no [data-nrm-cf-atc], so they navigate normally. */
    section.querySelectorAll('[data-nrm-cf-card]').forEach(function (card) {
      var btn = card.querySelector('[data-nrm-cf-atc]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-has-variants') === 'true') {
          var dataEl = card.querySelector('[data-nrm-cf-product-data]');
          var product = null;
          try { product = JSON.parse(dataEl.textContent); } catch (e) { product = null; }
          if (product) {
            openModal(product);
          } else {
            var link = card.querySelector('a');
            if (link) window.location.href = link.getAttribute('href');
          }
          return;
        }
        var variantId = btn.getAttribute('data-variant-id');
        if (variantId) addToCart(variantId, btn);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.nrm-cf').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.nrm-cf');
    if (s) { s.dataset.nrmCfInit = 'false'; initSection(s); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
